import { openBlock as l, createElementBlock as t, createElementVNode as e } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, o = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M8.371 15.227c0-1.234 1.704-4.611 2.777-6.616l.013-.025a90.655 90.655 0 0 1 .498-.916.389.389 0 0 1 .683 0 82.235 82.235 0 0 1 .498.916l.013.025c1.073 2.005 2.777 5.382 2.777 6.616a3.63 3.63 0 0 1-7.259 0Zm5.758 0a2.13 2.13 0 1 1-4.258 0v.001a.76.76 0 0 1 .01-.077 2.32 2.32 0 0 1 .049-.233c.05-.198.128-.447.236-.741.216-.59.521-1.29.866-2.021.314-.665.652-1.336.968-1.946.317.61.655 1.281.968 1.946.345.732.65 1.432.866 2.02.108.295.187.544.237.742.025.099.04.176.05.233a.59.59 0 0 1 .008.077Z",
  "clip-rule": "evenodd"
}, null, -1), n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M5.006 22.545h14l-.01-.01c.96 0 1.75-.79 1.75-1.75v-8.26h1.25a.751.751 0 0 0 .53-1.28l-9.29-9.28a1.75 1.75 0 0 0-2.47 0l-9.29 9.28c-.21.22-.28.54-.16.82.11.28.39.46.69.46h1.25v8.27c0 .96.79 1.75 1.75 1.75Zm14.25-1.75c0 .14-.11.25-.25.25-2.644 0-4.148-.002-5.77-.004-1.902-.003-3.968-.006-8.23-.006-.14 0-.25-.11-.25-.25v-9.01c0-.41-.34-.75-.75-.75h-.19l8.02-8c.09-.1.25-.1.35 0l8.01 8h-.19c-.41 0-.75.34-.75.75v9.02Z",
  "clip-rule": "evenodd"
}, null, -1), d = [
  o,
  n
];
function r(a, h) {
  return l(), t("svg", c, [...d]);
}
const s = { render: r };
export {
  s as default,
  r as render
};
